module.exports = __webpack_public_path__ + "css/glideMain.css";